import { REACT_APP_COOKIES_DOMAIN, STORAGE_PRFX, SSO_URL, FRONTEND_URL } from './config';
import moment from 'moment';
import 'moment-timezone';
import ct from 'countries-and-timezones';

// ::: cookie
export const setCookie = (cname, cvalue, exdays = 7, skip = false) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = `${
    skip ? cname : STORAGE_PRFX + cname
  }=${cvalue};${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
  document.cookie = `${STORAGE_PRFX}AUTH_ORIGIN=Push_SSO;${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
  //  console.log('Cookies set:', document.cookie)
};

export const getCookie = (cname, skip = false) => {
  var name = `${skip ? cname : STORAGE_PRFX + cname}=`;
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.split('=')[1].length !== 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return '';
};

export const deleteCookie = (cname, skip = false) => {
  var expires = 'expires=-1';
  document.cookie = `${skip ? cname : STORAGE_PRFX + cname}=;${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
};

// ::: storage
export const setStorage = (name, value) => {
  return localStorage.setItem(STORAGE_PRFX + name, value);
}
export const getStorage = (name, value) => {
  return localStorage.getItem(STORAGE_PRFX + name, value);
}
export const delStorage = (name) => {
  return localStorage.removeItem(STORAGE_PRFX + name);
}

export const titleCase = str => {
  return str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
export const numberFormatter = x => {
  return x
    .toFixed(4)
    .toString()
    .replace(/\B(?=(\d{5})+(?!\d))/g, ',');
};

export const truncate = (str, n) => {
  return str.slice(0, n);
};

export const getTimeZone = ccc => {
  // let as = '';
  const countries = ct.getAllCountries();
  let d = Object.values(countries);
  let aa = d.find(e => e.name === ccc);

  if (aa) {
    return aa.timezones[0];
  } else {
    return moment.tz.guess();
  }
};

export const generateOptions = (length, disabledOptions, hideDisabledOptions, step = 1) => {
  const arr = [];
  for (let value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }
  return arr;
};


export const mergeObj = (obj, src) => {
  for (var key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key];
  }
  return obj;
}

// check permission
export const hasP = (permission, myRole) => {
  var check = (process.env[`REACT_APP_${permission}`] || '').split(',').findIndex(role => role === (myRole || 'manager'));
  if (check === -1) {
    return false;
  }
  return true;
}

export const getApiBaseUrl = () => {
  // var protocol = window.location.protocol;
  // var hostName = window.location.hostname;
  // var port = window.location.port;
  console.log("I am calling sso url")
  return SSO_URL;
  // return (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === FRONTEND_URL) ? SSO_URL : `${protocol}//${hostName}${(port === 80) ? '' : ':' + port}/api/v2`;
}


export const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}